import { type PropsWithChildren, useEffect, useState } from "react";

interface ToggleProps extends PropsWithChildren {
  onClick: () => void;
  forceActive?: boolean;
}

export function Toggle(props: ToggleProps) {
  const [active, setActive] = useState(false);

  useEffect(() => setActive(props.forceActive ?? false), [props.forceActive]);

  const handleToggle = () => {
    if (props.forceActive === undefined) setActive(!active);
    props.onClick();
  };

  return (
    <button
      className={`rounded-full relative grid place-content-center w-8 h-8 transition-all duration-300 bg-opacity-80 ${
        !active ? "text-gray-900 bg-white" : "border border-gray bg-gray-900 text-gray-300"
      }`}
      onClick={handleToggle}
    >
      {props.children}
    </button>
  );
}
